import React, { Component, createRef } from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import Spin from 'src/components/Spin'
import { LocationType } from 'src/app/constants'
import { logError, isEmpty } from 'src/utils/helpers'
import intlMessages from 'src/components/Maps/translations'
import styles from './GoogleMapFindBar.module.less'
import './GoogleMapFindBar.less'
import FontAwesomeIconComponent from 'src/components/FontAwesomeIcon/index'

const LocationIconColors = {
  [LocationType.Cache]: '#818d9a',
  [LocationType.Alt]: '#3e5064',
  [LocationType.Unknown]: '#c8cbd1',
  [LocationType.Geo]: '#1cc0a9',
}

class GoogleMapFindBar extends Component {
  state = {
    isSearchLoading: false,
    isFindMeLoading: false,
    isFindMe: false,
  }

  constructor(props) {
    super(props)

    this.findBarRef = createRef()
    this.searchFieldRef = createRef()
  }

  componentDidMount() {
    this.initSearch()
  }

  initSearch = () => {
    try {
      const {
        google,
        map,
        onNewLocationFound,
        onNewLocationNotFound,
        onNewLocationStart,
      } = this.props

      if (!(google && google.maps)) {
        logError('google.maps not available in props on init search', null, 0)
        return false
      }

      if (!(this.searchFieldRef && this.searchFieldRef.current)) {
        logError('Search field DOM element not found on init search', null, 0)
        return false
      }

      // if(this.findBarRef && this.findBarRef.current) {
      //   map.controls[google.maps.ControlPosition.TOP_LEFT].push(this.findBarRef.current)
      // }

      const searchBox = new google.maps.places.SearchBox(this.searchFieldRef.current, {
        types: ['geocode', 'address', '(regions)', '(cities)'],
      })

      // Bias the SearchBox results towards current map's viewport.
      map.addListener('bounds_changed', () => {
        searchBox.setBounds(map.getBounds())
      })

      // TODO: PAT-2318 Prevent searching when enter is clicked, do it only when new location is selected

      // Listen for the event fired when the user selects a prediction and retrieve more details for that place.
      searchBox.addListener('places_changed', () => {
        this.setState({
          isSearchLoading: true,
        })

        if (typeof onNewLocationStart === 'function') {
          onNewLocationStart()
        }

        const places = searchBox.getPlaces()

        const latLng = this.getPlaceLocation(places)

        if (!latLng) {
          // Hide loading after a delay, to make it clear we tried to find new location
          setTimeout(() => {
            this.setState({
              isSearchLoading: false,
            })

            if (typeof onNewLocationNotFound === 'function') {
              onNewLocationNotFound()
            }
          }, 1000)
          return false
        }

        onNewLocationFound(map, latLng, () => {
          this.setState({
            isSearchLoading: false,
          })
        })
      })
    } catch (e) {
      logError('Init map search', e)
    }
  }

  /**
   * Extract lat/lng location from found place/s.
   *
   * @param places
   * @return {{ lat: number, lng: number }|null}
   */
  getPlaceLocation = places => {
    try {
      if (!(places && places.length > 0)) {
        return null
      }

      if (
        !(
          places[0] &&
          places[0].hasOwnProperty('geometry') &&
          places[0].geometry.hasOwnProperty('location')
        )
      ) {
        return null
      }

      if (isEmpty(places[0].geometry.location)) {
        return null
      }

      const location = places[0].geometry.location

      if (!(location.lat && location.lng)) {
        return null
      }

      const lat = typeof location.lat === 'function' ? location.lat() : null
      const lng = typeof location.lng === 'function' ? location.lng() : null

      if (!(lat && lng)) {
        return null
      }

      this.setState({
        isFindMe: false,
      })

      return {
        lat: lat,
        lng: lng,
      }
    } catch (e) {
      logError('Get place location', e)
      return null
    }
  }

  /**
   * Handle clicking on search icon or close (x) icon.
   *
   * @param {Event} event
   * @param {boolean} shouldClear Should we also clear the search field
   * @return {boolean}
   */
  searchIconClick = (event, shouldClear = false) => {
    try {
      event.preventDefault()

      if (!(this.searchFieldRef && this.searchFieldRef.current)) {
        logError('Search field DOM element not found on search icon click', null, 0)
        return false
      }

      if (shouldClear) {
        this.searchFieldRef.current.value = ''
      }
      // this.searchFieldRef.current.focus()

      return true
    } catch (e) {
      logError('Clear map search', e)
      return false
    }
  }

  /**
   * When find me "target" icon is clicked.
   *
   * @param {Event} event Click event
   */
  onFindMyLocationClick = event => {
    const { onFindMyLocation } = this.props

    event.preventDefault()

    if (this.searchFieldRef && this.searchFieldRef.current) {
      this.searchFieldRef.current.value = ''
    }

    this.setState({
      isFindMeLoading: true,
    })

    onFindMyLocation(() => {
      this.setState({
        isFindMeLoading: false,
        isFindMe: true,
      })
    })
  }

  render() {
    const { intl, myLocationType } = this.props

    const { isSearchLoading, isFindMeLoading } = this.state

    return (
      <div className={styles.findBarHolder} ref={this.findBarRef}>
        <div className={styles.findBarHolderInner}>
          <div className={styles.searchHolder}>
            <div className={styles.searchHolderInner}>
              {isSearchLoading ? (
                <div className={styles.loadingSearchIconHolder}>
                  <Spin size='small' />
                </div>
              ) : (
                <div className={styles.searchIconHolder} onClick={this.searchIconClick}>
                  <FontAwesomeIconComponent
                    icon={['far', 'magnifying-glass']}
                    size={'xs'}
                    type='input-icon-color'
                  />
                </div>
              )}
              <div className={styles.searchFieldHolder}>
                <input
                  ref={this.searchFieldRef}
                  name='mapFindLocation'
                  className={styles.searchInput}
                  placeholder={intl.formatMessage(intlMessages.mapFindLocationFieldPlaceholder)}
                  type='text'
                />
              </div>
              <button
                className={styles.clearSearchIconHolder}
                onClick={e => this.searchIconClick(e, true)}
              >
                <FontAwesomeIconComponent
                  icon={['far', 'xmark']}
                  size={'xs'}
                  type='input-icon-color'
                />
              </button>
            </div>
          </div>
          <div>
            <div className={styles.findMyLocation} onClick={this.onFindMyLocationClick}>
              {isFindMeLoading ? (
                <div className={styles.loadingFindMeIconHolder}>
                  <Spin size='small' />
                </div>
              ) : (
                <button className={styles.findMyLocationIconHolder}>
                  <FontAwesomeIconComponent
                    addClassName={styles.locationIcon}
                    icon={['fal', 'location-crosshairs']}
                    size={'sm'}
                    color={LocationIconColors[myLocationType]}
                  />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

GoogleMapFindBar.propTypes = {
  google: PropTypes.object.isRequired,
  map: PropTypes.object.isRequired,
  myLocationType: PropTypes.oneOf(['unknown', 'cache', 'geo', 'alt']),
  onNewLocationFound: PropTypes.func.isRequired,
  onNewLocationNotFound: PropTypes.func,
  onNewLocationStart: PropTypes.func,
  onFindMyLocation: PropTypes.func.isRequired,
}

export default injectIntl(GoogleMapFindBar)
